module.exports = __webpack_public_path__ + "media/images/landing/icon-growing-2095c62c60cca968380deaaef101d7c1.svg";